import React from 'react';
import demoVideo from '../assets/demo.webm';

const DemoVideo = () => {
    const styles = {
        section: {
            padding: '100px 32px',
            background: 'linear-gradient(135deg, #3457D5 0%, #2B47B0 100%)',
        },
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
        },
        header: {
            textAlign: 'center',
            marginBottom: '60px',
            color: '#FFFFFF',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '16px',
        },
        highlight: {
            color: '#F28C46',
        },
        subtext: {
            fontSize: '20px',
            lineHeight: '1.7',
            opacity: 0.9,
        },
        videoWrapper: {
            position: 'relative',
            borderRadius: '24px',
            overflow: 'hidden',
            boxShadow: '0 30px 80px rgba(0,0,0,0.4)',
            background: '#000000',
        },
        video: {
            width: '100%',
            height: 'auto',
            display: 'block',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
    }

    return (
        <section style={styles.section} id="demo">
            <div style={styles.container}>
                <div style={styles.header}>
                    <h2 style={styles.h2}>
                        See Corpusio in <span style={styles.highlight}>Action</span>
                    </h2>
                    <p style={styles.subtext}>
                        Watch how our AI-powered solutions transform enterprise communication
                    </p>
                </div>

                <div style={styles.videoWrapper}>
                    <video
                        style={styles.video}
                        controls
                        autoPlay
                        muted
                        loop
                        playsInline
                    >
                        <source src={demoVideo} type="video/webm" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </section>
    );
};

export default DemoVideo;
